import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { EntityActions } from "../EntityActions";
/** A component, not a string: the header has to be translated at render time. */ function ActionsColumnHeader() {
    const { t } = useTranslation();
    return /*#__PURE__*/ _jsx("div", {
        className: "sr-only",
        children: t("common.actions")
    });
}
/**
 * Create a standardized actions column for data tables.
 */ export function createActionsColumn({ onView, onEdit, onClone, onDelete, getCustomActions, isRowDisabled, isRowPending } = {}) {
    return {
        id: "actions",
        meta: {
            sticky: "right",
            fitContent: true
        },
        header: ()=>/*#__PURE__*/ _jsx(ActionsColumnHeader, {}),
        cell: ({ row })=>{
            const disabled = isRowDisabled?.(row.original) ?? false;
            return /*#__PURE__*/ _jsx(EntityActions, {
                onView: onView ? ()=>onView(row.original) : undefined,
                onEdit: onEdit ? ()=>onEdit(row.original) : undefined,
                onClone: onClone ? ()=>onClone(row.original) : undefined,
                onDelete: onDelete ? ()=>onDelete(row.original) : undefined,
                viewDisabled: disabled,
                editDisabled: disabled,
                cloneDisabled: disabled,
                deleteDisabled: disabled,
                customActions: getCustomActions?.(row.original).map((action)=>disabled ? {
                        ...action,
                        disabled: true
                    } : action),
                pending: isRowPending?.(row.original) ?? false
            });
        },
        enableSorting: false,
        enableHiding: false
    };
}

//# sourceMappingURL=actions-column.js.map